require('./mortgageRequestAssociatedAccount.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');

const MortgageRequestAssociatedAccount = props => {
    const { accountNumber, balance } = props;
    let content = null;
    const currencyHelpParams = {
        currency: balance
    };

    if (accountNumber && balance) {
        content = (
            <div className="mortgage-request-associated-account row ">
                <div className="mortgage-request-associated-account__wrapper col-xs-9">
                    <h4>
                        <FormattedText value="mortgageRequestAssociatedAccount-title" />
                    </h4>
                    <FormattedText
                        value="mortgageRequestAssociatedAccount-description"
                        className="mortgage-request-associated-account__description"
                    />

                    <FormattedText
                        className="mortgage-request-associated-account__description--bold"
                        value="mortgageRequestAssociatedAccount-descriptionBold"
                    />

                    <div className="mortgage-request-associated-account__balance row no-outside-gutter">
                        <div className="col-xs-offset-10 col-xs-2">
                            <FormattedText
                                value="mortgageRequestAssociatedAccount-balance"
                                className="mortgage-request-associated-account__balance__text"
                            />
                        </div>
                    </div>

                    <div className="mortgage-request-associated-account__information row no-outside-gutter">
                        <div className="mortgage-request-associated-account__number col-xs-9">
                            <span>
                                {accountNumber}
                            </span>
                        </div>

                        <div className="mortgage-request-associated-account__value col-xs-3">
                            <span>
                                {MortgageRequestCurrencyHelp(currencyHelpParams)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return content;
};

MortgageRequestAssociatedAccount.propTypes = {
    accountNumber: PropTypes.string.isRequired,
    balance: PropTypes.string.isRequired
};

MortgageRequestAssociatedAccount.defaultProps = {
    accountNumber: '',
    balance: ''
};

module.exports = MortgageRequestAssociatedAccount;
